import { useState, useEffect, SetStateAction, Dispatch } from 'react';



export const useDebounce = (value: string, milliSeconds: number, setPageNumber?: Dispatch<SetStateAction<number>>) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
            setPageNumber?.(1)
        }, milliSeconds);

        return () => {
            clearTimeout(handler);
        };
    }, [value, milliSeconds]);

    return debouncedValue;
};